const caseTypeMeta = {
  base: 'collection',
  derivedFromTypeId: null,
  id: 'CE-6OB5-XJ2L',
  name: 'Collection_11',
  version: 1,
}

export default caseTypeMeta
